import { Button, Table, Tooltip, message, Space, Typography, Select } from "antd";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { ProblemasTableFormFilter } from "./problemas-table-form-filter";
import { TableCustom } from "../../../components/table";
import { ParagraphPopup } from "../../../components/paragraphPopup";
import {
  UnorderedListOutlined,
  ClockCircleOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { status_actions, status_actions_text, status_text } from "../../../utils/pda-status";
import { storageSet } from "../../../services/storage";
import dayjs from "dayjs";
import http from "../../../services/http";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ProblemasAvaliacoesTableForm } from "./problemas-avaliacoes-table-form";
const { Text } = Typography;

const options_status = [
  {
    value: -1,
    label: (
      <Text style={{ color: "#df6d06cc" }}>
        <ClockCircleOutlined /> Aguardando
      </Text>
    ),
    disabled: true,
  },
  {
    value: 1,
    label: (
      <Text style={{ color: "#60b565" }}>
        <CheckCircleOutlined /> Alcançado
      </Text>
    ),
  },
  {
    value: 2,
    label: (
      <Text style={{ color: "#2e5b00cc" }}>
        <CheckCircleOutlined /> Alcançado parcial
      </Text>
    ),
  },
  {
    value: 4,
    label: (
      <Text style={{ color: "#ff4d4f" }}>
        <CloseCircleOutlined /> Não alcançado
      </Text>
    ),
  },
  {
    value: 3,
    label: (
      <Text style={{ color: "#1677ff" }}>
        <ClockCircleOutlined /> Em andamento
      </Text>
    ),
  },
  {
    value: 0,
    label: (
      <Text type="secondary">
        <CloseCircleOutlined /> Cancelado
      </Text>
    ),
  },
];

const columns_actions = [
  {
    title: "Ação (Como?)",
    dataIndex: "descricao",
    className: "fontSmall",
    width: 500,
    render: (_, e) => <ParagraphPopup text={e?.descricao} title="Ação (Como?)" />,
  },
  {
    title: "Responsável (Quem?)",
    dataIndex: "colaborador",
    className: "fontSmall",
  },
  {
    title: "Início",
    dataIndex: "data_inicio",
    className: "fontSmall",
    width: 50,
    render: (_, e) => dayjs(e?.data_inicio).format("DD/MM/YYYY"),
    renderText: (e) => dayjs(e?.data_inicio).format("DD/MM/YYYY"),
  },
  {
    title: "Fim",
    dataIndex: "data_fim",
    className: "fontSmall",
    width: 50,
    render: (_, e) => dayjs(e?.data_fim).format("DD/MM/YYYY"),
    renderText: (e) => dayjs(e?.data_fim).format("DD/MM/YYYY"),
  },
  {
    title: "Status",
    dataIndex: "status",
    className: "fontSmall",
    width: 50,
    render: (_, e) => status_actions[e?.status],
    renderText: (e) => status_actions_text[e?.status],
  },
];

const columns = [
  {
    title: "Nº",
    dataIndex: "id",
    width: 50,
    className: "fontSmall",
  },
  {
    title: "Filial/Setor/Colab. (Onde?)",
    dataIndex: "setor",
    className: "fontSmall",
    render: (_, e) => e?.setor ?? e?.responsavel,
    renderText: (e) => e?.setor ?? e?.responsavel,
  },
  {
    title: "Apontamento (O que?)",
    dataIndex: "oque",
    className: "fontSmall",
    width: 300,
    render: (_, e) => <ParagraphPopup text={e?.oque} title="Apontamento (O que?)" />,
  },
  {
    title: "Motivo (Por quê?)",
    className: "fontSmall",
    dataIndex: "porque",
    width: 300,
    render: (_, e) => <ParagraphPopup text={e?.porque} title="Motivo (Por quê?)" />,
  },
];

const ProblemasAvaliacoesTable = ({ onChangeStatus }) => {
  const navigate = useNavigate();
  const filterRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const [showModal, setShowModal] = useState(false);
  const [idAlt, setIdAlt] = useState(null);
  const modo_visualizacao = searchParams.get("modo_visualizacao_a") ?? 1;

  const [acoes, setAcoes] = useState([]);
  const [dados, setDados] = useState([]);

  useEffect(() => {
    filterRef.current?.submitForm();
  }, []);

  const listarProblemas = async (filtro) => {
    filtro.data_inicio = dayjs(filtro?.data_inicio).format("YYYY-MM-DD");
    filtro.data_fim = dayjs(filtro?.data_fim).format("YYYY-MM-DD");
    setLoading(true);
    const api = await http(
      "get",
      `v1/problemas/listar_avaliacoes?id_sistemas_origens=${filtro?.id_sistemas_origens}&status=${filtro?.status}&data_inicio=${filtro?.data_inicio}&data_fim=${filtro?.data_fim}&status_acoes=${filtro?.status_acoes}`,
      []
    );

    if (api.statusCode === 200) {
      const response = api?.response?.data ?? [];
      setDados(response);
      let array_acoes = [];
      for (const el of response) {
        array_acoes = [...array_acoes, ...el?.acoes];
      }
      setAcoes(array_acoes);
    } else {
      message.error(api.response.message);
    }
    storageSet("f_apda", JSON.stringify(filtro));
    setLoading(false);
  };

  const alterarStatus = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/problemas/alterar_status`, formulario);
    if (api.statusCode === 200) {
      const data = dados;
      let index = dados?.findIndex((e) => e?.id === formulario?.id);

      if (index > -1) {
        data[index].status = formulario?.status;
        setDados(data);
      }
      onChangeStatus();
      message.success("Status alterado com sucesso!");
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  const avaliarAcao = useCallback(async (id) => {
    setIdAlt(id);
    setShowModal(true);
  }, []);

  const onFinish = useCallback(() => {
    setIdAlt(null);
    setShowModal(false);
    filterRef.current.submitForm();
  }, []);

  const onClose = useCallback(() => {
    setIdAlt(null);
    setShowModal(false);
  }, []);

  const renderActions = (acoes) => (
    <Table
      loading={loading}
      columns={[
        ...columns_actions,
        ...[
          {
            title: "Ações",
            dataIndex: "actions",
            sorter: false,
            width: 50,
            render: (_, e) => (
              <Space.Compact>
                <Tooltip title="Avaliar">
                  {[-1, 3].includes(e?.status_problema) && (
                    <Button icon={<EditOutlined />} onClick={() => avaliarAcao(e?.id)} />
                  )}
                </Tooltip>
              </Space.Compact>
            ),
          },
        ],
      ]}
      dataSource={acoes.acoes}
      pagination={false}
      bordered
      size="small"
      rowKey="id"
    />
  );

  return (
    <>
      <ProblemasAvaliacoesTableForm onFinish={onFinish} open={showModal} onClose={onClose} id={idAlt} />
      <ProblemasTableFormFilter
        name="modo_visualizacao_a"
        ref={filterRef}
        onFinish={listarProblemas}
        loading={loading}
      />
      <br />
      {Number(modo_visualizacao) === 1 && (
        <TableCustom
          loading={loading}
          columns={[
            ...columns,
            ...[
              {
                title: "Status",
                dataIndex: "status",
                className: "fontSmall",
                width: 170,
                render: (_, e) => (
                  <Select
                    placeholder="Selecione o status"
                    style={{ width: 170 }}
                    disabled={loading || !e?.id_colaborador_atendente > 0}
                    className="fontSmall"
                    value={e?.status}
                    onChange={(val) =>
                      alterarStatus({
                        id: e?.id,
                        status: val,
                      })
                    }
                    options={options_status}
                  />
                ),
                renderText: (e) => status_text[e?.status],
              },
              {
                title: "Ações",
                dataIndex: "acoes",
                sorter: false,
                width: 80,
                render: (_, e) => (
                  <Space.Compact>
                    <Tooltip title="Detalhes">
                      <Button
                        onClick={() => navigate(`/planos-acao/avaliacoes/detalhes/${e.id}`)}
                        icon={<UnorderedListOutlined />}
                      />
                    </Tooltip>
                  </Space.Compact>
                ),
              },
            ],
          ]}
          dataSource={dados}
          expandable={{
            expandedRowRender: (data_children) => renderActions(data_children),
            expandIcon: ({ expanded, onExpand, record }) => (
              <Button type={expanded ? "primary" : "default"} onClick={(e) => onExpand(record, e)}>
                Ações ({record.acoes.length})
              </Button>
            ),
          }}
        />
      )}

      {Number(modo_visualizacao) === 2 && (
        <TableCustom
          rowClassName={(e) => (dayjs(e?.data_fim) < dayjs() && [-1, 2, 3].includes(e?.status) ? "danger" : "")}
          loading={loading}
          columns={[
            ...[
              {
                title: "Nº",
                dataIndex: "id_problemas",
              },
            ],
            ...columns_actions,
            ...[
              {
                title: "Ações",
                dataIndex: "actions",
                sorter: false,
                width: 50,
                render: (_, e) => (
                  <Space.Compact>
                    <Tooltip title="Detalhes">
                      <Button
                        loading={loading}
                        onClick={() => navigate(`/planos-acao/avaliacoes/detalhes/${e.id_problemas}`)}
                        icon={<UnorderedListOutlined />}
                      />
                    </Tooltip>
                    <Tooltip title="Avaliar">
                      {[-1, 3].includes(e?.status_problema) && (
                        <Button icon={<EditOutlined />} onClick={() => avaliarAcao(e?.id)} />
                      )}
                    </Tooltip>
                  </Space.Compact>
                ),
              },
            ],
          ]}
          dataSource={acoes}
        />
      )}
    </>
  );
};

export { ProblemasAvaliacoesTable };
